import { getNewsMediaPulseTracker } from "..";

const trackViewSJPartnerPage = (id: string, name: string) => {
  const newsMediaPulseTracker = getNewsMediaPulseTracker();

  newsMediaPulseTracker?.executeNewsMediaPulseCommand("trackViewPage", {
    object: {
      pageId: id,
      name: name,
    },
  });
};
export { trackViewSJPartnerPage };
